export enum LiveViewRoutesEnum{
    PREFIX = 'live_view'

}